$(document).on("turbolinks:load", function() {
  $(".navbar-burger").click((e) => {
    $(".navbar-burger").toggleClass("is-active");
    $(".menu-burger").toggleClass("is-hidden");
  });

  $(".menu-burger .is-overlay").click((e) => {
    $(".navbar-burger").removeClass("is-active");
    $(".menu-burger").addClass("is-hidden");
  });
});

// Updates counter in cart icons in the header
window.updateHeaderCart = function(cart) {
  let itemCount = cart.items.length;
  let $counters = $("header .shopping-cart .item-count");

  $counters.text(itemCount);
  $counters.toggleClass("is-hidden", itemCount <= 0);
}
